import { z } from 'zod';
import { UuidString } from '../../primitives.js';

/**
 * TaskProjectMembership — членство задачи в проекте (junction
 * `task_module_task_projects`, task-multi-project-and-roles BB1).
 *
 * Одна задача живёт в нескольких проектах; ровно один `is_primary`. Позиция и
 * поддерево (`sort_order`/`parent_task_id`) — per-project (D6). `project_id`
 * на самой задаче остаётся primary-денормом (проект is_primary-строки).
 *
 * Без strict-режима (B6) — forward-compat FE-parse: новые backend-поля не роняют список.
 */
export const TaskProjectMembership = z.object({
  project_id: UuidString,
  is_primary: z.boolean(),
  /** Fractional float — per-project позиция в этом проекте. */
  sort_order: z.number().finite(),
  /** Родитель в контексте этого проекта (per-project поддерево); null — корень. */
  parent_task_id: UuidString.nullable(),
});
export type TaskProjectMembership = z.infer<typeof TaskProjectMembership>;

/**
 * Directory-запись проекта для bundle (денорм code/name) — FE рендерит чип
 * проекта без N+1. Structural, рядом с tasks[] (не раздуваем strict Task).
 */
export const TaskProjectDirectoryEntry = z.object({
  project_id: UuidString,
  code: z.string().nullable(),
  name: z.string(),
});
export type TaskProjectDirectoryEntry = z.infer<typeof TaskProjectDirectoryEntry>;
